import type { RewardEffect, ResourceType } from "@/core";
import type { Stat } from "@/core/roscha";
import type { FloatingRewardEvent } from "../app/GameApp";

const RESOURCE_ICON: Record<ResourceType, string> = {
  gold: "🪙",
  mana: "💧",
};

const RESOURCE_TEXTURE: Record<ResourceType, string> = {
  gold: "resIconGold",
  mana: "resIconMana",
};

const RESOURCE_COLOR: Record<ResourceType, string> = {
  gold: "#fbbf24",
  mana: "#8b5cf6",
};

const STAT_SHORT: Record<Stat, string> = {
  strength: "СИЛ",
  dexterity: "ЛОВ",
  intelligence: "ИНТ",
  wisdom: "МУД",
  constitution: "ТЕЛ",
};

export function floatingFromResource(type: ResourceType, amount: number): FloatingRewardEvent {
  return {
    icon: RESOURCE_ICON[type] ?? "❔",
    iconTexture: RESOURCE_TEXTURE[type],
    label: `+${amount}`,
    color: RESOURCE_COLOR[type] ?? "#fbbf24",
  };
}

export function floatingFromEffect(effect: RewardEffect): FloatingRewardEvent | null {
  switch (effect.type) {
    case "resource":
      return floatingFromResource(effect.resourceType, effect.amount);
    case "hp":
      return { icon: "❤", label: `+${effect.amount} HP`, color: "#ef4444" };
    case "energy":
      return { icon: "⚡", label: `+${effect.amount}`, color: "#22d3ee" };
    case "stat": {
      const sign = effect.delta >= 0 ? "+" : "";
      return { icon: "✦", label: `${sign}${effect.delta} ${STAT_SHORT[effect.stat]}`, color: "#a78bfa" };
    }
    case "equipment":
      return null;
    case "xp":
      return floatingXp(effect.amount);
  }
}

export function floatingXp(amount: number): FloatingRewardEvent {
  return { icon: "⭐", label: `+${amount} XP`, color: "#fde047" };
}

export function floatingReputation(amount: number): FloatingRewardEvent {
  return { icon: "🏛", label: `+${amount} реп.`, color: "#60a5fa" };
}
